<img [src]="profilePictureUrl" [class]="'phx-profile-picture status-' + statusType" *ngIf="profilePictureUrl!=null"
    (error)="handleMissingPicture($event)" alt="" />

<ng-container *ngIf="profilePictureUrl===null">
    <i *ngIf="!showInitials" class="material-icons">account_circle</i>
    <div *ngIf="showInitials" [class]="'initials-outer status-' + statusType">
        <div class="initials-inner">{{initials}}</div>
    </div>
</ng-container>